





























import { Component, Prop, Watch } from 'vue-property-decorator';
import Modal from '@/project/modals/Modal.vue';
import LoginPanel from './LoginPanel.vue';
import ForgotPasswordPanel from './ForgotPasswordPanel.vue';
import ResetPasswordPanel from './ResetPasswordPanel.vue';
import ChangePasswordPanel from './ChangePasswordPanel.vue';
import GTMBasics from '@/project/tracking/gtm/GTM.basics';

@Component({
    components: { ResetPasswordPanel, ForgotPasswordPanel, LoginPanel, ChangePasswordPanel }
})
export default class AuthenticationModuleOverlay extends Modal {
    @Prop({ required: true, type: String })
    initialState!: 'login' | 'forgot-pw' | 'reset-pw' | 'change-pw';

    @Prop({ required: false, type: String })
    redirect!: string;

    state: '' | 'login' | 'forgot-pw' | 'reset-pw' | 'change-pw' = '';

    @Watch('state')
    onStateChange(newState: string) {
        this.trackLoginStateChange(newState);
    }

    trackLoginStateChange(newState) {
        GTMBasics.pushToDataLayer({
            event: 'login.click',
            loginState: newState
        });
    }

    created() {
        this.state = this.initialState;
    }
}
